import { api } from '../api';
import type { ContextNode, TagRow } from '@/types/domain';

export const contextsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listContexts: builder.query<ContextNode[], void>({
      query: () => '/contexts',
      providesTags: [{ type: 'Context', id: 'LIST' }],
    }),
    getContext: builder.query<ContextNode, number>({
      query: (id) => `/contexts/${id}`,
      providesTags: (_r, _e, id) => [{ type: 'Context', id }],
    }),
    createContext: builder.mutation<ContextNode, { name: string; parentId?: number }>({
      query: (body) => ({ url: '/contexts', method: 'POST', body }),
      invalidatesTags: [{ type: 'Context', id: 'LIST' }],
    }),
    updateContext: builder.mutation<ContextNode, { id: number; name?: string; parentId?: number | null }>({
      query: ({ id, ...body }) => ({ url: `/contexts/${id}`, method: 'PATCH', body }),
      invalidatesTags: [{ type: 'Context', id: 'LIST' }],
    }),
    deleteContext: builder.mutation<void, number>({
      query: (id) => ({ url: `/contexts/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Context', id: 'LIST' }],
    }),
  }),
});

export const tagsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listTags: builder.query<TagRow[], void>({
      query: () => '/tags',
      providesTags: [{ type: 'Tag', id: 'LIST' }],
    }),
    createTag: builder.mutation<TagRow, { name: string; color?: string; description?: string }>({
      query: (body) => ({ url: '/tags', method: 'POST', body }),
      invalidatesTags: [{ type: 'Tag', id: 'LIST' }],
    }),
    updateTag: builder.mutation<TagRow, { id: number; name?: string; color?: string; active?: boolean }>({
      query: ({ id, ...body }) => ({ url: `/tags/${id}`, method: 'PATCH', body }),
      invalidatesTags: [{ type: 'Tag', id: 'LIST' }],
    }),
    deleteTag: builder.mutation<void, number>({
      query: (id) => ({ url: `/tags/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Tag', id: 'LIST' }],
    }),
  }),
});

export const {
  useListContextsQuery,
  useGetContextQuery,
  useCreateContextMutation,
  useUpdateContextMutation,
  useDeleteContextMutation,
} = contextsApi;

export const {
  useListTagsQuery,
  useCreateTagMutation,
  useUpdateTagMutation,
  useDeleteTagMutation,
} = tagsApi;
